import React from 'react';
import useUnsavedChanges from '../../hooks/useUnsavedChanges';
import ConfirmDialog from './ConfirmDialog';

export default function UnsavedChangesNotice({ dirty, busy = false, localOnly = false, children }: {
  dirty: boolean; busy?: boolean; localOnly?: boolean; children?: React.ReactNode;
}) {
  const blocker = useUnsavedChanges(dirty || busy, false, busy);
  return <>
    {(dirty || busy) && <div role="status" className="mb-6 flex flex-wrap items-center justify-between gap-3 rounded-xl border border-amber-200 bg-amber-50 p-4 text-sm text-amber-900">
      <div><p className="font-semibold">{busy ? 'Vorgang läuft …' : localOnly ? 'Inhalte noch nicht übernommen' : 'Ungespeicherte Änderungen'}</p>
        <p className="mt-1">{busy ? 'Bitte warte, bis der Vorgang abgeschlossen ist.' : localOnly ? 'Diese Inhalte sind nur auf dieser Seite vorhanden. Kopiere oder lade dein Ergebnis herunter, bevor du die Seite verlässt.' : 'Speichere deine Änderungen, bevor du die Seite verlässt.'}</p></div>
      {children}
    </div>}
    <ConfirmDialog open={blocker.state === 'blocked'} title={busy ? 'Vorgang läuft noch' : 'Seite verlassen?'}
      description={busy ? 'Bitte warte auf den Abschluss, damit der Vorgang nicht unterbrochen wird.' : 'Beim Verlassen gehen die noch nicht übernommenen Eingaben auf dieser Seite verloren.'}
      confirmLabel="Seite verlassen" cancelLabel="Auf Seite bleiben" danger confirmDisabled={busy}
      onClose={() => { if (blocker.state === 'blocked') blocker.reset(); }}
      onConfirm={() => { if (!busy && blocker.state === 'blocked') blocker.proceed(); }} />
  </>;
}
